import { render } from "./Tm_leftnavi.vue?vue&type=template&id=397b3b63&scoped=true&ts=true"
import script from "./Tm_leftnavi.vue?vue&type=script&lang=ts"
export * from "./Tm_leftnavi.vue?vue&type=script&lang=ts"

import "./Tm_leftnavi.vue?vue&type=style&index=0&id=397b3b63&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1530414395/src/mediadept-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-397b3b63"]])

export default __exports__